module.exports = __webpack_public_path__ + "static2023-4-17/img/active_banner.d1650dbc.jpg";